export default __webpack_public_path__ + "static/media/chat-board.a0c2d9d2.png";